import { RowRendererProps } from 'react-arborist'
import { v4 as uuidv4 } from 'uuid'

function TreeRow<T>({ attrs, innerRef, children }: RowRendererProps<T>) {
  return (
    <div
      {...attrs}
      key={uuidv4()}
      ref={innerRef}
      style={{
        ...attrs.style,
        transition: 'transform 160ms ease, opacity 160ms ease'
      }}
      onFocus={(e) => e.stopPropagation()}
      onClick={(e) => {
        // Issue https://github.com/brimdata/react-arborist/issues/120
        // node.handleClick messup with the multiselect
        e.stopPropagation()
      }}
    >
      {children}
    </div>
  )
}

export default TreeRow
